import config from './config.json';

// Determina l'ambiente corrente
const environment = process.env.REACT_APP_ENV || 'development';

// Carica la configurazione per l'ambiente corrente dal JSON
const jsonConfig = config[environment];

// --- CALCOLO CENTRALIZZATO PATH ---
const rawBasePath = process.env.REACT_APP_ROUTER_BASE_PATH || ''; // Es: '/ui-dashboard' o ''

let routerBasePath = rawBasePath;

// Aggiunge "/" iniziale se manca (solo se esiste un path)
if (routerBasePath && !routerBasePath.startsWith('/')) {
  routerBasePath = '/' + routerBasePath;
}

if (environment === 'production' && !routerBasePath.endsWith('/')) {
  routerBasePath += '/';
}

// Ottieni l'origine corrente (https://host:port), gestendo il caso non-browser
const appOrigin = typeof window !== 'undefined' ? window.location.origin : '';

// Costruisci il path assoluto base dell'applicazione
const appPath = appOrigin + routerBasePath;

// --- FINE CALCOLO ---

const appConfig = {
  ...jsonConfig,
  ROUTER_BASE_PATH: routerBasePath,
  ROUTER_BASENAME: routerBasePath || '/', // Per <BrowserRouter basename>
  APP_PATH: appPath,
  CAPTCHA_KEY: process.env.REACT_APP_CAPTCHA_KEY || "6Lc5SqMqAAAAAAwyVjPKgyynrSsVDg5Jl_oHXizW" // Sensibile. Bisognerebbe creare key di sviluppo
};

export default appConfig;